<template>
  <div class="my-client">
    <div class="client-top">
      <div class="con-search">
        <van-field v-model="value" placeholder="搜索手机号/昵称/姓名" />
        <div class="s-icon" @click="onSearch">
          <img src="@/assets/publicImg/search.png" alt />
        </div>
      </div>
      <ul>
        <li v-for="(item,index) in liList" :key="index" @click="onClick(item)">
          <div class="li-v" :class="checkLi==item.type? 'li-v check-li-v':'li-v'">
            <div class="li-v-v">{{item.value}}</div>
            <div class="li-v-n">{{item.name}}</div>
          </div>
          <p class="line-icon"></p>
        </li>
      </ul>
    </div>
    <div class="v-data">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="v-info-box" v-for="(item,index) in dataList" :key="index">
            <!-- <div class="info-div" > -->
            <div @click.stop="toDetail(item)" class="v-img">
              <img :src="item.headImg" alt />
            </div>
            <div class="v-div" @click.stop="toDetail(item)">
              <div class="v-name">{{item.username}} ({{item.phoneNo}})</div>
              <div class="v-name">
                访问足迹共{{item.footCounts}}次，今日新增{{item.todayCount}}次
                <span v-if="checkLi=='item'">进件{{item.itemCount}}次</span>
                <span v-if="checkLi=='loan'">放款{{item.loanCount}}次</span>
              </div>
              <div class="v-time">{{item.createTime}} 成为我的客户</div>
            </div>
            <div class="v-right">></div>
            <div class="check-icon">
              <van-checkbox :key="index" v-model="item.newStatus" @change="toSetStatus(item)">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? inactiveIcon : activeIcon" />
                </template>
              </van-checkbox>
            </div>
            <!-- </div> -->
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import { Toast } from 'vant';
export default {
  data() {
    return {
      value: '',
      liList: [],
      checkLi: 'normal',
      dataList: [
        // { name: '大姐姐', status:'0',phone:'13000000000',new:'1',foot:'4', value: '成为我的客户', time: '2022-08-17  20:14:14', img: require(`../../assets/img/user.png`) },
        // { name: '大姐姐', status:'1',phone:'13000000000',new:'1',foot:'4', value: '成为我的客户', time: '2022-08-17  20:14:14', img: require(`../../assets/img/user.png`) },
      ],
      checked: null,//关注
      activeIcon: require('@/assets/publicImg/checkbox0.png'),
      inactiveIcon: require('@/assets/publicImg/checkbox1.png'),
      page:1,
      size:10,
      total:0,
      loading: false,
      finished: false,
      refreshing: false,

    }
  },
  mounted() {
    this.clientsType()
  },
  methods: {
    onSearch(val) {//搜索
    this.dataList=[]
      this.getData()
    },
    clientsType() {//客户类型
      let data = {
        agentUserId: localStorage.getItem('userid')
      }
      this.$fetchPost(URLTB.getClientsType.url, data).then(res => {
        this.liList = res.data.data
        this.checkLi = res.data.data[0].type
      })
    },
    onLoad(){
      if(this.checkLi=='normal'){
        this.getnormal()//普通访客数据
      }else if(this.checkLi=='attention'){
        this.getattention()//关注客户数据
      }else if(this.checkLi=='item'){
        this.getitem()//进件客户数据
      }else{
        this.getloan()//放款客户数据
      }
    },
    onRefresh() {
      this.page=1
      this.dataList=[]
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getnormal(){//普通访客数据
      this.getData()
    },
    getattention(){//关注客户数据
      this.getData()
    },
    getitem(){//进件客户数据
      this.getData()
    },
    getloan(){//放款客户数据
      this.getData()
    },
    getData() {
      let that =this
      let data = {
        cusType: that.checkLi,
        agentUserId: localStorage.getItem('userid'),
        searchStr: that.value,
        page: that.page,
        size: that.size
      }
      that.$fetchPost(URLTB.getClients.url, data).then(res => {
        that.refreshing=false
        that.loading=false
        let list = res.data.data.list.records
        list.map(x => {
          that.$set(x, 'newStatus', false)
          if (x.attention == '1') {
            that.$set(x, 'newStatus', true)
          }
        })
        that.total = res.data.data.list.total
        if(list == null || list.length<=0){
          //加载完成
          that.finished=true
          return
        }
        if(that.page>1){
          that.dataList = [...that.dataList ,...list]
        }else{
          that.dataList = list 
        }
        if(that.page*that.size>=that.total){
          that.finished=true
          return
        }
         
        if(that.page*that.size<that.total){
        that.page++
        }
        
      })
    },
    //操作按钮间接给status赋值（后台需要的字段）
    toSetStatus(item) {//修改关注状态
      if (item.newStatus) {
        item.attention = '1'
      } else {
        item.attention = '0'
      }
      let data = {
        agentUserId: localStorage.getItem('userid'),
        cusUserId: item.userId,
        attention: item.attention
      }
      this.$fetchPost(URLTB.clientsAttention.url, this.$toFormData(data)).then(res => {
        if (res.data.code == 20000) {
          Toast(res.data.msg)
          this.onLoad()
          this.clientsType()
        }
      })
    },
    onClick(item) {
      this.checkLi = item.type
      if(item.type=='normal'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getnormal()//普通访客数据
      }else if(item.type=='attention'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getattention()//关注客户数据
      }else if(item.type=='item'){
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getitem()//进件客户数据
      }else{
        this.page=1
        this.dataList=[]
        this.loading=true
        this.finished=false
        this.getloan()//放款客户数据
      }
      
    },
    toDetail(item) {
      this.$router.push({ path: '/clientMaterial', query: { userId: item.userId } })
    }
  }
}
</script>

<style lang="less" scoped>
.my-client {
  height: 100vh;
  // background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  img {
    width: 100%;
    height: 100%;
  }
  .client-top {
    width: 375px;
    height: 143px;
    background: url("./img/bg1.png") no-repeat 100%;
    background-size: 100% 100%;
  }
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
      img {
        width: 14px;
        height: 14px;
        margin-left: 13px;
      }
    }
  }
  ul {
    width: 355px;
    height: 78px;
    background: url("./img/bg.png") no-repeat 50%;
    background-size: 100% 100%;
    margin: 13px auto auto;
    display: flex;
    font-size: 11px;
    color: #333333;
    justify-content: space-around;
    .line-icon {
      width: 1px;
      height: 18px;
      background: #d4d4d4;
    }
    li {
      height: 78px;
      display: flex;
      align-items: center;

      text-align: center;
      &:last-child > .line-icon {
        display: none;
      }
      .check-li-v {
        color: #fc6e09;
      }
      .li-v {
        width: 70px;
        .li-v-v {
          font-size: 14px;
          font-weight: bold;
        }
        .li-v-n {
          margin-top: 12px;
        }
      }
    }
  }
  .v-data {
    width: 355px;
    margin: 15px auto auto;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
    .v-info-box {
      width: 355px;
      height: 80px;
      margin: auto;
      background: url("../../assets/publicImg/con-bg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      position: relative;
      margin-bottom: 10px;
      .v-title-time {
        margin: 10px 0;
      }
      .v-img {
        width: 45px;
        height: 45px;
      }
      .v-div {
        margin-left: 18px;
        .v-name {
          margin-bottom: 5px;
          font-weight: 500;
          font-size: 12px;
        }
      }
      .v-right {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #d4d4d4;
      }
      .check-icon {
        position: absolute;
        top: 15px;
        right: 16px;
        .img-icon {
          width: 15px;
          height: 13px;
        }
      }
    }
  }
}
</style>